import * as templatesActions from '@literax/modules/templates/store/templates.actions';

import { Action, createReducer, on } from '@ngrx/store';
import { ETemplateFlow } from '@literax/enums/template.enum';
import {
  ITemplatesState,
  initialTemplatesState,
} from '@literax/modules/templates/store/templates.state';
import {
  TemlateFilterFieldTypeData,
  TemplateFilterColumn,
  TemplateFilterFieldTypeOperator,
} from '@literax/constans/template.constants';

import { ITemplateFilterField } from '@literax/models/templates';

const templateReducer = createReducer(
  initialTemplatesState,
  on(templatesActions.indexTemplate, (state, action) => {
    const templates = [];
    const pagination = action.pagination
      ? { ...state.pagination, ...action.pagination }
      : state.pagination;
    return { ...state, templates, pagination };
  }),
  on(templatesActions.indexTemplateSuccess, (state, action) => {
    const templates = [...state.templates, ...action.payload.templates];
    return {
      ...state,
      templates,
      pagination: {
        currentPage: state.pagination.currentPage,
        pageSize: state.pagination.pageSize,
        total_count: action.payload.pagination.total_count,
        total_pages: action.payload.pagination.total_pages,
      },
    };
  }),
  on(templatesActions.CreateTemplateError, (state, action) => ({
    ...state,
    error: action.payload,
  })),
  on(templatesActions.getFlowsSuccess, (state, action) => ({
    ...state,
    flows: action.payload,
  })),
  on(templatesActions.changeFlow, (state, action) => {
    const pagination = action.pagination
      ? { ...state.pagination, ...action.pagination }
      : state.pagination;
    return {
      ...state,
      currentPage: 1,
      templates: [],
      selectedFlow: action.templateFlow,
      pagination,
    };
  }),
  on(templatesActions.latestSuccess, (state, action) => ({
    ...state,
    latest: action.payload,
  })),
  on(templatesActions.changeDepartment, (state, action) => ({
    ...state,
    currentDepartment: action.payload,
  })),
  on(templatesActions.changeKind, (state, action) => ({
    ...state,
    currentPage: 1,
    templates: [],
    kind: action.payload,
  })),
  on(templatesActions.MetadataTemplateProfileSuccess, (state, action) => {
    const MetadataTemplateProfileCurrentPage =
      action.payload.length > 0
        ? state.metadataTemplateProfilesCurrentPage + 1
        : state.metadataTemplateProfilesCurrentPage;
    return {
      ...state,
      metadataTemplateProfiles: action.payload,
      MetadataTemplateProfileCurrentPage,
    };
  }),
  on(templatesActions.ClearMetadataTemplateProfile, (state, action) => ({
    ...state,
    metadataTemplateProfiles: [],
    metadataTemplateProfilesCurrentPage: 1,
  })),
  on(templatesActions.GetProfilesSuccess, (state, action) => ({
    ...state,
    profiles: action.payload,
  })),
  on(templatesActions.GetTemplateStadistics, (state, action) => {
    return {
      ...state,
      templateFieldData: null,
    };
  }),
  on(templatesActions.GetTemplateStadisticsSuccess, (state, action) => {
    const templateFieldData = action.payload;
    return {
      ...state,
      templateFieldData,
    };
  }),
  on(templatesActions.GetCollectorsByTemplateSuccess, (state, action) => ({
    ...state,
    collectors: action.payload,
  })),
  on(templatesActions.GetSignersByTemplateSuccess, (state, action) => ({
    ...state,
    signers: action.payload,
  })),
  on(templatesActions.ApplyFilter, (state, action) => ({
    ...state,
    templateFieldData: null,
    templateFieldDataActiveFilter: action.filterParams,
    templateFieldDataCurrentPage: 1,
  })),
  on(templatesActions.ChangeCurrentSort, (state, action) => ({
    ...state,
    templateFieldDataCurrentSort: action.columnSort,
    templateFieldData: null,
    templateFieldDataCurrentPage: 1,
  })),
  on(templatesActions.CleanTemplateStadistics, (state, _) => ({
    ...state,
    templateFieldData: null,
    templateFieldDataCurrentPage: 1,
  })),
  on(templatesActions.CreateTemplateSuccess, (state, action) => ({
    ...state,
    templateUpdate: action.payload.template,
  })),
  on(templatesActions.DeleteTemplate, (state, action) => ({
    ...state,
    currentPage: 1,
    templates: [],
    selectedFlow: ETemplateFlow.TEMPLATE_DRAFT,
  })),
  on(templatesActions.Get, (state, action) => {
    const pageN = action.payload?.pageNumber ? action.payload?.pageNumber : state.queryParameters?.pageNumber;
    const pageS = action.payload?.pageSize ? action.payload?.pageSize : state.queryParameters?.pageSize;
    // The payload's filters replace the current ones (a search does not accumulate, FR-022);
    // a payload with no filterFields keeps the current ones (paging).
    const filters: ITemplateFilterField[] = action?.payload?.filterFields
      ? [...action.payload.filterFields]
      : state.queryParameters?.filterFields ?? [];
    // A payload with no sortField keeps the current sort.
    const sorts = action?.payload?.sortField
      ? { ...state.queryParameters?.sortField, ...action.payload.sortField }
      : state.queryParameters?.sortField ?? null;
    return {
      ...state,
      queryParameters: {
        pageNumber: pageN,
        pageSize: pageS,
        filterFields: filters,
        sortField: sorts
      }
    }
  }),
  on(templatesActions.GetSuccess, (state, action) => ({
    ...state,
    ...action.payload,
  })),
  on(templatesActions.ChangeStatus, (state, action) => ({
    ...state,
    queryParameters:
      action?.status !== null && action?.status !== undefined
        ? {
            pageNumber: 1,
            pageSize: 10,
            sortField: null,
            filterFields: [
              {
                name: TemplateFilterColumn.STATUS_NAME,
                term: action.status,
                type: TemlateFilterFieldTypeData.TEXT,
                operator: TemplateFilterFieldTypeOperator.EQ,
              },
            ],
          }
        : {
            pageNumber: 1,
            pageSize: 10,
            sortField: null,
            filterFields: [],
          },
  })),
  on(templatesActions.ChangeTemplateKind, (state, action) => ({
    ...state,
    currentPage: 1,
    templates: [],
    // Stored as the numeric kind; 0 (Documento) is a kind, only null/undefined mean "every kind".
    kindV3: action.kind ?? null,
    forceDepartments: action.forceDepartments ?? false,
  })),
  on(templatesActions.CreateTemplateV3Success, (state, action) => ({
    ...state,
    templateById: action.payload,
    templateUpdateV3: { ...action.payload }
  })),
  on(templatesActions.CreateTemplateV3Error, (state, action) => ({
    ...state,
    error: action.payload,
  })),
  on(templatesActions.GetTemplateByIdSuccess, (state, action) => ({
    ...state,
    templateById: action.payload,
    templateUpdateV3: { ...action.payload },
  })),
  on(templatesActions.GetTemplateByIdError, (state, action) => ({
    ...state,
    error: action.payload,
  })),
  on(templatesActions.CreateelationTemplateMetaDataSuccess, (state, action) => ({
    ...state,
    templateUpdateV3: action.payload,
    fieldsOnlyOfficeV3: action.payload?.fields,
  })),
  on(templatesActions.updateTemplateNameDepartmentsSuccess, (state, action) => ({
    ...state,
    templateById: action.payload,
    templateUpdateV3: { ...action.payload },
  })),
  on(templatesActions.ResetTemplatesData, (state) => ({
    ...state,
    templatesV3: [],
    paginationV3: null,
    kindV3: null,
    forceDepartments: false,
    queryParameters: {
      pageNumber: 1,
      pageSize: 10,
      sortField: null,
      filterFields: [],
    }
  })),
  on(
    templatesActions.ProcessTemplateV3Success,
    templatesActions.UpdateTemplateFieldRequiredV3Success,
    templatesActions.RemoveTemplateFieldV3Success,
    (state, action) => ({
      ...state,
      templateById: action.payload,
      templateUpdateV3: { ...action.payload },
    })
  ),
  on(templatesActions.GetTemplateCatalogV3Success, (state, action) => ({
    ...state,
    templateCatalogV3: [...state.templateCatalogV3, ...action.payload.fields],
    templateCatalogPaginationV3: action.payload.pagination,
  })),
  on(templatesActions.ClearTemplateCatalogV3, (state) => ({
    ...state,
    templateCatalogV3: [],
    templateCatalogPaginationV3: null,
  })),
  on(templatesActions.GetTemplateStatusSummaryV3Success, (state, action) => ({
    ...state,
    templateStatusSummaryV3: action.payload,
  })),
  on(templatesActions.SetTemplateFieldsSearch, (state, action) => ({
    ...state,
    templateFieldsSearch: action.term ?? '',
  })),
  on(
    templatesActions.GetError,
    templatesActions.ProcessTemplateV3Error,
    templatesActions.DeleteTemplateV3Error,
    templatesActions.UpdateTemplateFieldRequiredV3Error,
    templatesActions.RemoveTemplateFieldV3Error,
    templatesActions.GetTemplateCatalogV3Error,
    templatesActions.GetTemplateStatusSummaryV3Error,
    templatesActions.CreateelationTemplateMetaDataError,
    (state, action) => ({
      ...state,
      error: action.payload,
    })
  )
);

export function templatesReducer(state: ITemplatesState, action: Action) {
  return templateReducer(state, action);
}
